import { render, staticRenderFns } from "./WordByWord.vue?vue&type=template&id=4c2f5b24&scoped=true&"
import script from "./WordByWord.vue?vue&type=script&lang=js&"
export * from "./WordByWord.vue?vue&type=script&lang=js&"
import style0 from "./WordByWord.vue?vue&type=style&index=0&id=4c2f5b24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2f5b24",
  null
  
)

export default component.exports